module.exports = __webpack_public_path__ + "media/images/emblems/Menznau_LU-b23339c79ffe5b20ee798569b53b951b.png";